import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Close } from 'styled-icons/material/Close';
import styled, { css } from 'styled-components';

import COLORS from '../colors';

function getWrapperStyle({ size, width, height, radius }) {
  if (size === 'full-screen') {
    return css`
      width: 100%;
      height: 100%;
      max-height: 100%;
    `;
  }

  if (size === 'custom') {
    return css`
      width: ${width};
      height: ${height};
      max-height: ${height};
      border-radius: ${radius || '8px'};
    `;
  }

  return css`
    width: 420px;
    min-height: 56px;
    max-height: calc(100vh - 60px);
    border-radius: 8px;
  `;
}

const Wrapper = styled.div`
  position: relative;
  ${props => getWrapperStyle(props)};
  overflow: ${({ overflow }) => overflow};
  ${({ transparent, bg }) =>
    !transparent &&
    css`
      background: ${bg || COLORS.WHITE};
      box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.4);
    `};
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${({ top }) => top || 0}px;
  right: ${({ right }) => right || 0}px;
  padding: 12px;
  cursor: pointer;
`;

const CloseIcon = styled(Close)`
  color: ${COLORS.GRAY};
`;

const HangingCloseIcon = styled(Close)`
  color: white;
  right: 0;
  position: absolute;
  top: 0;
`;

const HangingCloseIconWrapper = styled.div`
  position: relative;
  padding: 16px 36px;
`;

export default class Modal extends PureComponent {
  static propTypes = {
    bg: PropTypes.string,
    Comp: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    transparent: PropTypes.bool,
    overflow: PropTypes.string,
    blocking: PropTypes.bool,
    size: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    props: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    outSideCloseButton: PropTypes.bool,
    top: PropTypes.number,
    right: PropTypes.number,
  };

  static defaultProps = {
    bg: COLORS.WHITE,
    transparent: false,
    overflow: 'auto',
    blocking: false,
    size: 'normal',
    outSideCloseButton: false,
    top: 0,
    right: 0,
  };

  renderModal() {
    const {
      Comp,
      props,
      bg,
      blocking,
      transparent,
      size,
      outSideCloseButton,
      onClose,
      ...other
    } = this.props;

    return (
      <Wrapper
        className="wrapper"
        size={size}
        bg={bg}
        transparent={transparent}
        {...other}
      >
        <Comp transparent={transparent} {...props} closeModal={onClose} />
        {!blocking && !outSideCloseButton ? (
          <CloseButtonWrapper onClick={onClose}>
            <CloseIcon size={18} />
          </CloseButtonWrapper>
        ) : null}
      </Wrapper>
    );
  }

  render() {
    const { outSideCloseButton, onClose, top, right } = this.props;

    return outSideCloseButton ? (
      <HangingCloseIconWrapper>
        <CloseButtonWrapper onClick={onClose} top={top} right={right}>
          <HangingCloseIcon size={32} />
        </CloseButtonWrapper>
        {this.renderModal()}
      </HangingCloseIconWrapper>
    ) : (
      this.renderModal()
    );
  }
}
